import React, { useRef, useState } from "react";
import { InputFail } from "../../../../../Components/Form";
import InputSearchProps from "../inputProps";
import { Form, Formik } from "formik";
import * as vald from "../../static/valdaitions";
import LinearProgress from "@mui/material/LinearProgress";
import { Box } from "@mui/system";
import { useParams } from "react-router-dom";

import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";

import ImageIcon from "@mui/icons-material/Image";
import { IconButton } from "@mui/material";

import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";

import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import Typography from "@mui/material/Typography";
import DeleteIcon from "@mui/icons-material/Delete";

import AddIcon from "@mui/icons-material/Add";
import { POST_REQUEST } from "../../../../../HooksApi/useApi";
import { USeInsertData } from "../../../../../HookAxios/postData";
import { useSelector } from "react-redux";
import HookVedCourse from "../../../../../hooks/VedCourse";
import { useSnackbar } from "notistack";

const FormComment = () => {
  //@Component State
  const [open, setOpen] = React.useState(false);
  const [images, setImages] = useState([]);
  const [error, setError] = useState("");

  ///===================
  const { refetchPending } = HookVedCourse();
  const { enqueueSnackbar } = useSnackbar();

  const user = useSelector((state) => state.Auth.userInfo.data);
  const { idVed } = useParams();
  const [newComment, setNewComment] = React.useState("");
  const [Status, setStatus] = React.useState(false);
  const [value, setValue] = React.useState("");

  const token = useSelector((state) => state.Auth.userInfo.token);

  //======================================================
  //@Formik

  const { mutate: addComment } = POST_REQUEST({
    request: (data) =>
      USeInsertData(`add_student_comment`, data, {
        Authorization: `Bearer ${token} `,
        "Content-Type": "multipart/form-data",
      }),
    handelOnSettledError,
    handelOnSettledData,
  });
  function handelOnSettledError(error) {
    setNewComment("");
    setStatus(false);
  }
  function handelOnSettledData(data) {
    refetchPending();
    setStatus(false);
    setOpen(false);
    setValue("");
    setImages([]);
    enqueueSnackbar("تم إرسال السؤال بنجاح", { variant: "success" });
  }

  const onSubmit = (data, { resetForm }) => {
    setNewComment({
      comment: data.comment,
      user_name: user.username,
      image_path: user.image_path,
    });
    setStatus(true);
    const formData = new FormData();

    formData.append("session", idVed);
    formData.append("comment", data.comment);
    for (let i = 0; i < images.length; i++) {
      formData.append("images[]", images[i]);
    }

    addComment(formData);
    setTimeout(() => {
      resetForm();
    }, 2000);
  };

  // ============================================================

  //@Regular Handler
  const handleClickOpen = () => {
    setOpen((prev) => !prev);
  };

  function handleFileInputChange(event) {
    const files = event.target.files;

    if (images.length < 5) {
      setImages((prev) => [...prev, ...files]);
    } else {
      setError("يسمح باضافة 5 صور على الاكثر");
    }
  }

  const fileInputRef = useRef(null);

  function handleButtonClick() {
    fileInputRef.current.click();
  }

  function handleDeleteImage(index) {
    setImages((prev) => prev.filter((image, i) => i !== index));
  }

  function onDragEnd(result) {
    setImages((pre) => {
      const newValue = Array.from(pre);
      const temp = pre[result.source.index - 1];
      newValue[result.source.index - 1] = pre[result.destination.index - 1];
      newValue[result.destination.index - 1] = temp;
      return newValue;
    });
  }

  return (
    <>
      <Formik
        initialValues={vald.formikProps.initialValues}
        validationSchema={vald.formikProps.validationSchema}
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={onSubmit}
        render={({
          handleChange,
          handleBlur,
          values,
          errors,
          touched,
          setFieldValue,
        }) => (
          <Form
            autoComplete="off"
            style={{
              width: "100%",
              bottom: "0",
              margin: "15px auto",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            {!Status ? (
              <Box sx={{ width: "100%", position: "relative" }}>
                <InputFail
                  width="100%"
                  onChange={(e) => [handleChange(e)]}
                  onBlur={handleBlur}
                  value={values.comment}
                  error={errors.comment && touched.comment}
                  errorText={
                    errors.comment && touched.comment ? errors.comment : null
                  }
                  name="comment"
                  placeholder="هل لديك سؤال؟"
                  inputProps={InputSearchProps}
                  borderradius="24px"
                  border="1px solid #00000029"
                />

                <IconButton
                  sx={{
                    position: "absolute",
                    top: "4px",
                    right: "60px",
                    color: "#000",
                  }}
                  onClick={handleClickOpen}
                >
                  <ImageIcon />
                </IconButton>
              </Box>
            ) : (
              <Box style={{ width: "50%", marginTop: "15px" }}>
                <LinearProgress height="48px" />
              </Box>
            )}
            {open && (
              <DragDropContext onDragEnd={onDragEnd}>
                <Typography sx={{ color: "#DA3B3B", mt: "10px" }}>
                  {" "}
                  {error}
                </Typography>
                <Droppable
                  style={{ position: "relative" }}
                  isDropDisabled={false}
                  droppableId={"images-list"}
                  type="images"
                >
                  {(provided) => (
                    <div ref={provided.innerRef} {...provided.droppableProps}>
                      {images?.map((img, index) => (
                        <Draggable
                          key={img.name + index}
                          draggableId={img.name + index}
                          index={index + 1}
                        >
                          {(provide) => (
                            <div
                              ref={provide.innerRef}
                              {...provide.draggableProps}
                              {...provide.dragHandleProps}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  borderRadius: "4px",
                                  border: "1px solid #F0F0F0",
                                  background: "#FFF",
                                  padding: "10px 20px",
                                  my: "10px",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    gap: "20px",
                                  }}
                                >
                                  <IconButton>
                                    <DragIndicatorIcon />
                                  </IconButton>
                                  <Box sx={{ width: "100px" }}>
                                    <img
                                      src={URL.createObjectURL(img)}
                                      alt={img.name}
                                      style={{ width: "100%" }}
                                    />
                                  </Box>
                                  <Typography>{img.name}</Typography>
                                  <Typography>
                                    (Mb {(img.size / 1024 ** 2).toFixed(3)} )
                                  </Typography>
                                </div>
                                <IconButton
                                  onClick={() => handleDeleteImage(index)}
                                >
                                  <DeleteIcon sx={{ color: "#DA3B3B" }} />
                                </IconButton>
                              </Box>
                            </div>
                          )}
                        </Draggable>
                      ))}

                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>

                <Button
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "4px",
                    border: "1px solid #F0F0F0",
                    background: "#FFF",
                    padding: "10px 20px",
                    my: "10px",
                  }}
                  onClick={handleButtonClick}
                  disabled={images.length === 5}
                >
                  <AddIcon /> اضافة صورة
                </Button>

                <input
                  type="file"
                  accept="image/jpeg, image/png"
                  multiple
                  onChange={handleFileInputChange}
                  ref={fileInputRef}
                  style={{ display: "none" }}
                />
              </DragDropContext>
            )}
          </Form>
        )}
      />
    </>
  );
};

export default FormComment;

export const DialogWrapper = styled("div")(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  background: "#fff",
  boxShadow: "0px 10px 30px 0px rgba(0, 0, 0, 0.10)",
  display: "flex",
  flexDirection: "column",
  borderRadius: "10px",
  margin: "auto",
  width: "752px",
  maxHeight: "95vh",
  [theme.breakpoints.down("md")]: {
    gridTemplateColumns: ` 1fr`,
    padding: "10px",
    width: "90%",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxHeight: "620px",
  },
}));
